function objectToOption(object, indexes) {
  const displayValues = indexes.filter((i) => object[i]).map((i) => object[i]);

  return {
    label:
      (displayValues.length > 1
        ? `${displayValues[0]}, ${displayValues.slice(1).join(" ")}`
        : displayValues.join(" ")) || object.id,
    value: object.id,
    object: object,
  };
}

export default objectToOption;
